import { memo } from "react";

type Props = {
	children: React.ReactNode;
};

export const TodoListWrapper = memo(({ children }: Props) => {
	return <div className="grid grid-cols-1 gap-6 text-base">{children}</div>;
});

TodoListWrapper.displayName = "TodoListWrapper";
